/*
  Copyright (c) 2025 Fluxonix Inc. All rights reserved.
*/

import { api } from "../api";

export async function getAssigneeOptions() {
  const response = await api.get(
    "/api/secure/directory/assignees"
  );
  return response.data;
}